import { Component } from '@angular/core';
import {GoogleAnalyticsService} from "./services/google.service";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'ang-app';

  constructor(private gaService: GoogleAnalyticsService) {
    console.log("Google Tag Manager initialized.");
  }
}
